
import React from "react";
import { useNavigate } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import AccountCodeService from "../../../../services/AccountCodeService";
import { Button, Card, Col, Row } from "react-bootstrap";
import { useLoader } from "../../../../context/LoaderCotext";

const validationSchema = Yup.object().shape({
  projectRequired: Yup.string().oneOf(["Y", "N"]).required("Required"),
  accountName: Yup.string().required("Required"),
  accountNumber: Yup.string().required("Required"),
  project: Yup.string(),
  accountDescription: Yup.string().required("Required"),
  accountCategory: Yup.string().required("Required"),
});

const AddAccountCode = () => {
  const navigate = useNavigate();
  const { showLoader, hideLoader } = useLoader();

  const initialValues = {
    projectRequired: "N",
    accountName: "",
    accountNumber: "",
    project: "",
    accountDescription: "",
    accountCategory: "",
  };

  const handleSubmit = async (values) => {
    showLoader();
    try {
      await AccountCodeService.add(values);
      navigate("/settings/account-code");
    } catch (error) {
      console.error("Failed to add account code:", error);
    } finally {
      hideLoader();
      navigate("/settings/account-code");
    }
  };

  return (
    <div>
      <Card>
        <h1>Add Account Code</h1>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ errors, touched, isSubmitting }) => (
            <Form>
              <Row className="mb-3 mt-3">
                <Col>
                  <div className="form-group">
                    <label htmlFor="projectRequired">Project Required</label>
                    <Field
                      as="select"
                      name="projectRequired"
                      className="form-control"
                      controlId="formAccountcodeProjectRequired"
                    >
                      <option value="N">No</option>
                      <option value="Y">Yes</option>
                    </Field>
                    {errors.projectRequired && touched.projectRequired && (
                      <div className="text-danger">{errors.projectRequired}</div>
                    )}
                  </div>
                </Col>
                <Col>
                  <div controlId="formAccountcodeName" className="form-group">
                    <label htmlFor="accountName">Account Name</label>
                    <Field
                      type="text"
                      name="accountName"
                      placeholder="Enter account name"
                      className="form-control"
                      
                    />
                    {errors.accountName && touched.accountName && (
                      <div className="text-danger">{errors.accountName}</div>
                    )}
                  </div>
                </Col>
                <Col>
                  <div controlId="formAccountcodeNumber" className="form-group">
                    <label htmlFor="accountNumber">Account Number</label>
                    <Field
                      type="text"
                      name="accountNumber"
                      placeholder="Enter account number"
                      className="form-control"
                      
                    />
                    {errors.accountNumber && touched.accountNumber && (
                      <div className="text-danger">{errors.accountNumber}</div>
                    )}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div controlId="formAccountcodeProject" className="form-group">
                    <label htmlFor="project">Project</label>
                    <Field
                      type="text"
                      name="project"
                      placeholder="Enter project"
                      className="form-control"
                      controlId="formAccountcodeProject"
                    />
                    {errors.project && touched.project && (
                      <div className="text-danger">{errors.project}</div>
                    )}
                  </div>
                </Col>
                <Col>
                  <div controlId="formAccountcodeDescription" className="form-group">
                    <label htmlFor="accountDescription">Account Description</label>
                    <Field
                      type="text"
                      name="accountDescription"
                      placeholder="Enter account description"
                      className="form-control"
                      
                    />
                    {errors.accountDescription && touched.accountDescription && (
                      <div className="text-danger">{errors.accountDescription}</div>
                    )}
                  </div>
                </Col>
                <Col>
                  <div controlId="formAccountcodeCategory" className="form-group">
                    <label htmlFor="accountCategory">Account Category</label>
                    <Field
                      type="text"
                      name="accountCategory"
                      placeholder="Enter account category"
                      className="form-control"
                      
                    />
                    {errors.accountCategory && touched.accountCategory && (
                      <div className="text-danger">{errors.accountCategory}</div>
                    )}
                  </div>
                </Col>
              </Row>
              <div className="d-flex justify-content-end mt-3">
                <Button type="submit" variant="primary" disabled={isSubmitting}>
                  Add
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </Card>
    </div>
  );
};

export default AddAccountCode;